<template>
  <div class="img_card">
    <img class="img-fluid custom_size" src="../../../../../../images/chat-widget/no-vehicle-image.png" alt="">
  </div>
</template>
<script>
export default {
}
</script>
<style scoped>
.models_styles .img_card img {
  padding: 30px 30px;
}

.custom_size {
  max-height: 200px;
}
</style>
